import type { ReactNode } from 'react';

export const symbol_altitude: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M738.5-498.63Q730-507.25 730-520v-151l-54 52q-8.19 8.25-20.09 8.62-11.91.38-20.78-8.67-8.13-8.3-8.13-21.13 0-12.82 8-20.82l104-104q9-9 21-9t21 9l104 104q9 9 9 21t-9.05 21q-9.06 9-21.5 9-12.45 0-21.45-9l-52-52v151q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM100-80q-18.62 0-26.81-16.5Q65-113 76-128l180-240q4.5-6 10.88-9 6.37-3 13.12-3 6.75 0 13.13 3 6.37 3 10.87 9l171 228h325L560-459 459-325q-9 12.24-21 12.62-12 .38-21-6.42-9-6.79-12-18.5-3-11.7 6-23.7l125-167q4.54-6 10.96-9 6.43-3 13.24-3 6.8 0 12.8 3 6 3 11 9l300 400q11 15 2.81 31.5T860-80H100Zm375-60Z"
		/>
	</svg>
);
